import { pathBuilder } from 'config/paths/index';

export const root = '/admin/tags-V2';
export default pathBuilder(root);
